import { Injectable } from '@angular/core';
import { CxoneManageMetricsService } from 'src/app/cxone/admin/cxone-manage-metrics/cxone-manage-metrics.service';
import { AngularAssignToolService } from 'src/app/reusables/assign-tool/angular-assign-tool.service';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ReportingSetDynamicFiltersService } from '../../../reusables/reportingset-dynamic-filters/reportingset-dynamic-filters.service';
import { DashboardAccessService } from '../../modals/dashboard-access/dashboard-access.service';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';

@Injectable({
    providedIn: 'root'
})
export class CxoneDashboardFilterService {

    private recGroups = [] as any;

    private _agents = [] as any;
    private _teams = [] as any;
    private _skills = [] as any;
    //private _channels = [] as any;
    private _campaigns = [] as any;
    //private _directionTypes = [] as any;
    //private _mediaTypes = [] as any;
    private _dataAttr = [] as any;
    private _POCs = [] as any;
    private _dateParadigm = [] as any;
    private _onTheFlyEvals = [] as any;
    private _forms = [] as any;
    private _groups = [] as any;

    constructor(
        public manageMetricsService: CxoneManageMetricsService,
        //private attributeSelectorService: AttributeSelectorService,
        private dashboardAccessService: DashboardAccessService,
        private angularAssignToolService: AngularAssignToolService,
        private reportingSetDynamicFiltersService: ReportingSetDynamicFiltersService,
        private cvApiService: CVApiService,
        private localizationService: CVLocalizationService,
    ) { }

    get agents() {
        return this._agents;
    }

    get teams() {
        return this._teams;
    }

    get skills() {
        return this._skills;
    }

    //get channels() {
    //    return this._channels;
    //}

    get campaigns() {
        return this._campaigns;
    }

    //get directionTypes() {
    //    return this._directionTypes;
    //}

    //get mediaTypes() {
    //    return this._mediaTypes;
    //}

    get dataAttr() {
        return this._dataAttr;
    }

    get POCs() {
        return this._POCs;
    }

    get dateParadigm() {
        return this._dateParadigm;
    }

    get onTheFlyEvals() {
        return this._onTheFlyEvals;
    }

    get forms() {
        return this._forms;
    }

    get groups() {
        return this._groups;
    }

    async loadData() {
        const tasks = [
            this.localizationService.GetSection("Dashboard_Filter"),
            this.manageMetricsService.getRecGroups(),
            this.angularAssignToolService.loadEmpGroups(1),
            this.dashboardAccessService.loadTeams(),
            this.reportingSetDynamicFiltersService.loadReportFilters("Form Dim", "FORM", "FORM_KEY"),
            this.reportingSetDynamicFiltersService.loadReportFilters("Group Dim", "GROUP_NAME", "GROUP_ID")
        ];
        const results = await Promise.all(tasks);

        this.recGroups = results[1];

        this._agents = results[2];
        this._agents = this._agents?.map(({ groupDTO }) => ({ GroupID: groupDTO.GroupID, GroupName: groupDTO.GroupName })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));

        const loadedTeams: any = results[3];
        this._teams = loadedTeams?.map(({ groupDTO }) => ({ GroupID: groupDTO.GroupID, GroupName: groupDTO.GroupName })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));

        this._skills = Array.from(this.recGroups?.skills?.values())
            .map(({ GroupID, GroupName }: { GroupID: string; GroupName: string }) => ({ GroupID, GroupName })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));

        this._campaigns = Array.from(this.recGroups?.campaigns?.values())
            .map(({ GroupID, GroupName }: { GroupID: string; GroupName: string }) => ({ GroupID, GroupName })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));

        this._POCs = Array.from(this.recGroups?.pointsOfContact?.values())
            .map(({ GroupID, GroupName }: { GroupID: string; GroupName: string }) => ({ GroupID, GroupName })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));
        
        this._dateParadigm = Array(
            { GroupName: this.localizationService.getCachedText("Dashboard_Filter", "EVALUATION_START_TIME_PERIOD", "Evaluation Start Time Period"), GroupID: "EVALUATION_START_TIME_PERIOD", selected: false },
            { GroupName: this.localizationService.getCachedText("Dashboard_Filter", "EVALUATION_END_TIME_PERIOD", "Evaluation End Time Period"), GroupID: "EVALUATION_END_TIME_PERIOD", selected: false },
            { GroupName: this.localizationService.getCachedText("Dashboard_Filter", "RECORDED_INTERACTION_TIME_PERIOD", "Recorded Interaction Time Period"), GroupID: "RECORDED_INTERACTION_TIME_PERIOD", selected: false }
        ).sort((a, b) => a.GroupName.localeCompare(b.GroupName));

        this._onTheFlyEvals = Array(
            { GroupName: this.localizationService.getCachedText("Dashboard_Filter", "No", "No"), GroupID: "QP", selected: false },
            { GroupName: this.localizationService.getCachedText("Dashboard_Filter", "Yes", "Yes"), GroupID: "!#--DO NOT SEND FILTER--#!", selected: false },
        ).sort((a, b) => a.GroupName.localeCompare(b.GroupName));;

        this._forms = results[4];
        if (this._forms) {
            this._forms = this._forms?.map(form => ({ GroupID: form.Value, GroupName: form.DisplayValue })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));
        } else {
            this._forms = [];
        }

        this._groups = results[5];
        if (this._groups) {
            this._groups = this._groups?.map(group => ({ GroupID: group.Value, GroupName: group.DisplayValue })).sort((a, b) => a.GroupName.localeCompare(b.GroupName));
        } else {
            this._groups = [];
        }

        //const channels = await this.attributeSelectorService.loadValues(1012, AttributeType.Data);
        //this._channels = channels?.map(({ Name, ID }) => ({ GroupName: Name, GroupID: ID }));

        //this._mediaTypes = await this.attributeSelectorService.loadValues(935, AttributeType.Data);
        //this._mediaTypes = this._mediaTypes?.map(({ Name, ID }) => ({ GroupName: Name, GroupID: ID }));

        //this._directionTypes = await this.attributeSelectorService.loadValues(936, AttributeType.Data);
        //this._directionTypes = this._directionTypes?.map(({ Name, ID }) => ({ GroupName: Name, GroupID: ID }));

        //this._dataAttr = await this.attributeSelectorService.loadCategories(AttributeType.Data);
    }
}
